export enum LocationEndpoints {
  FetchLocations = '/locations',
	FetchAllCountries = '/locations/countries',
  FetchAllCities = '/locations/cities',
}
